import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EntitlementsService } from '../entitlements.service';
import { SharedService } from '../../shared/shared.service';
import { Alerts } from '../../shared/enums/alerts';
import { UsersService } from "../../users/users.service";
import { Roles } from "../../shared/enums/roles";
import { HomeService } from '../../home/home.service';
import { EntitlementBase } from '../entitlement-base';
import { EntitlementTo } from 'src/app/shared/models/entitlementTo';
import { SearchTypeTo } from 'src/app/shared/models/searchTypeTo';
import { SearchTypesService } from 'src/app/search-types/search-type.service';
import { PreferenceTo } from 'src/app/shared/models/preferenceTo';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
    selector: 'app-update-entitlements',
    templateUrl: './update-entitlements.component.html',
    styleUrls: ['./update-entitlements.component.scss']
})
export class UpdateEntitlementsComponent extends EntitlementBase implements OnInit {

    resetData: EntitlementTo;
    roles = Roles;
    header = "Update Entitlement";
    title: string;
    searchTypeList: Array<SearchTypeTo> = [];
    preferenceList: Array<PreferenceTo> = [];
    selectedPreferences: string[] = [];
    disableToggleButton: boolean = false;
    entitlementList: EntitlementTo[] = [];
    entitlementParentList: EntitlementTo[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) private data: EntitlementTo & { disableToggleButton: boolean },
                public dialogRef: MatDialogRef<UpdateEntitlementsComponent>,
                protected sharedService: SharedService,
                private entitlementsService: EntitlementsService,
                public usersService: UsersService,
                public homeService: HomeService,
                private searchTypesService: SearchTypesService) {
        super(); 
        this.disableToggleButton = this.data.disableToggleButton;
    }

    ngOnInit() {
        this.getAllSearchTypes();
        this.getAllPreferences();
        this.entitlement = new EntitlementTo(this.data);
        this.resetData = new EntitlementTo(this.data);
        this.title = this.entitlement.displayName;
        this.getEntitlementGroup();
        this.getAllEntitlements();
        if(this.data.disableToggleButton) {
            this.name.disable();
        }
    }

    getAllSearchTypes() {
        this.searchTypesService.getAllSearchTypes().subscribe({
            next: data => {
                this.searchTypeList = data;
            },
            error: error => {
                this.sharedService.showAlert(Alerts.ERROR, 'Failed to fetch SearchTypes to check mappings');
            },
            complete: () => { }
        });
    }

    getAllPreferences() {
        this.isLoading = true;
        this.entitlementsService.getAllPreferences().subscribe({
            next: data => {
                this.preferenceList = data;
                this.preferenceList.sort((a, b) => a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1);
                this.isLoading = false;
            },
            error: error => {
                this.sharedService.showAlert(Alerts.ERROR, 'Failed to fetch preferences');
                this.isLoading = false;
            },
            complete: () => { }
        });
    }

    getAllEntitlements() {
        this.isLoading = true;
        this.entitlementsService.getAllEntitlementDef().subscribe({
            next: data => {
                this.entitlementList = data;
                this.entitlementParentList.push(new EntitlementTo())
                data.sort((a, b) => a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1);
                data.forEach(e => this.entitlementParentList.push(e))
                this.filterListByEntitlement();
                this.isLoading = false;
            },
            error: error => {
                this.isLoading = false;
            },
            complete: () => { }
        });
    }

    filterListByEntitlement() {
        this.entitlementParentList = this.entitlementParentList.filter(entitlement => this.entitlement.id !== entitlement.id);
    }

    disableEntitlementParentIfEntitlementHasChildren() {
        return !!this.entitlementList.find(element => element.parentEntitlementId === this.entitlement.id);
    }

    getEntitlementGroup() {
        this.entitlementsService.getEntitlementGroup().subscribe ({
           next: data => {
               this.entitlementGroupList = data;
           }, 
           complete: () => { }
       })
   }

    updateEntitlements() {
        if ((this.name.valid || this.name.disabled) && this.displayName.valid && this.entitlement.orgType) {
            if (this.resetData.name !== this.entitlement.name ||
                    this.resetData.displayName !== this.entitlement.displayName ||
                    this.resetData.orgType !== this.entitlement.orgType || 
                    this.resetData.entitlementGroup !== this.entitlement.entitlementGroup ||
                    this.resetData.parentEntitlementId !== this.entitlement.parentEntitlementId ||
                    this.isPreferenesModified() ||
                    this.resetData.disabledBySafeMode !== this.entitlement.disabledBySafeMode) {
                this.isLoading = true;
                this.entitlement.entitlementGroup = (this.entitlement.entitlementGroup || '').trim();
                this.updateEntitlementWithSearchType();
            } else {
                this.sharedService.showAlert(Alerts.ERROR, 'No changes have been made');
                this.markFormControlsAsTouched();
            }
        }
    }

    isPreferenesModified() {
        if(this.resetData.preferences.length !== this.entitlement.preferences.length) {
            return true;
        }
        for (let preference of this.entitlement.preferences) {
            if (!this.resetData.preferences.includes(preference)) {
                return true;
            }
        }
        return false;
    }

    updateEntitlementWithSearchType() {
        this.entitlement.name = this.name.value;

        let mappedSearchTypes: Array<string> = [];
        this.searchTypeList.forEach(searchType => {
          if (searchType.entitlement === this.resetData.name) {
            mappedSearchTypes.push(searchType.name);
          }
        });
        
        this.entitlementsService.updateEntitlement(this.entitlement).subscribe({
            next: data => {
              this.isLoading = false;
              this.sharedService.showAlert(Alerts.SUCCESS, 'Entitlement updated successfully');
              this.dialogRef.close(true);
            },
            error: error => {
              this.isLoading = false;
              this.sharedService.handleErrors(error,
                [{
                  "condition": (error.status === 400 && Object.keys(error.error).length > 0),
                  "msg": error.error[Object.keys(error.error)[0]]
                }],
                "Unable to update entitlement");
            },
            complete: () => { }
          });
    }

    resetEntitlement() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.entitlement = new EntitlementTo(this.resetData);
                }
            });
        } else {
            this.entitlement = new EntitlementTo(this.resetData);
        }
    }

    close() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved !',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }

    protected readonly onselectionchange = onselectionchange;
}
